import React, { useCallback, useState, useRef } from 'react';

import './FormDSVUploader.scss';

import { FileUploader } from 'devextreme-react/file-uploader';

export const FormDSVUploader = ({ onValueChange, fileType }) => {
  const [isDropZoneActive, setDropZoneActive] = useState(false);

  const uploaderZone = useRef();

  const getAcceptString = () => {
    switch (fileType) {
      case 'DSV':
        return '.dsv7,.dsv8';
      case 'LENEX':
        return '.lxf,.lef';
      case 'AUTO':
        return '.dsv7,.dsv8,.lxf,.lef';
      default:
        return '/*';
    }
  };

  const getUploaderRef = useCallback(
    (element) => {
      uploaderZone.current = element;
    }, []);

  const onDropZoneEvent = useCallback((e) => {
    if (e.dropZoneElement.id === 'uploader') {
      setDropZoneActive(e.event?.type === 'dragenter');
    }
  }, []);

  const getDisplayText = () => {
    switch (fileType) {
      case 'DSV':
        return 'DSV7/8 Datei (.dsv7, .dsv8) hier rein ziehen oder hier klicken um Datei auszuwählen';
      case 'LENEX':
        return 'LENEX Datei (.lxf, .lef) hier rein ziehen oder hier klicken um Datei auszuwählen';
      case 'AUTO':
        return 'Wettkampf-Datei (.dsv7, .dsv8, .lxf, .lef) hier rein ziehen oder hier klicken um Datei auszuwählen';
      default:
        return `${fileType} Datei hier rein ziehen oder hier klicken um Datei auszuwählen`;
    }
  };

  return (
    <div>
      <div
        ref={getUploaderRef}
        id='uploader'
        className={`${ isDropZoneActive
          ? 'dx-theme-accent-as-border-color'
          : 'dx-theme-border-color' }`}
      >
        <span>{getDisplayText()}</span>
      </div>
      <FileUploader
        dialogTrigger={uploaderZone.current}
        dropZone={uploaderZone.current}
        multiple={false}
        accept={getAcceptString()}
        uploadMode='instantly'
        showFileList={false}
        visible={false}
        onDropZoneEnter={onDropZoneEvent}
        onDropZoneLeave={onDropZoneEvent}
        onValueChange={onValueChange}
      />
    </div>
  );
};
